/* @ngInject */
function GeneralPropertiesController ($rootScope, $scope, $timeout, $q, $translate, ModalService, UseTermsService, UdsModalService, FormatsService, ToastService, TagsService) {
  const getUseTermsCreateEditDialogController = () => $q.when(import('../../dialogs/use-terms/create-edit/use-terms-create-edit-dialog.controller'))
  const getCreateFormatController = () => import('../../../admin/dialogs/create-format/create-format.controller')
  const getCreateTagController = () => import('../../../admin/dialogs/create-tag/create-tag.controller')

  const ARTS_USE_TERMS = 'ARTS.USE_TERMS'
  let isRunningFormatSearch = false

  $scope.optional = {
    publication: false,
    expiration: false,
    terms: false,
    instructions: false
  }

  $scope.flags = {
    noFormats: false,
    noCategories: false,
    noUseTerms: false,
    suggestions: false,
    formatOptions: {
      top: 10,
      skip: 0,
      hasMoreOptions: false
    },
    categories: {
      top: 10,
      skip: 0,
      hasMoreOptions: false,
      hideSuggestions: false
    },
    useTerms: {
      pricing: false
    }
  }

  $scope.useTerms = []
  $scope.formats = []
  $scope.formatsSuggestions = []
  $scope.categories = []
  $scope.selectedCategories = []
  $scope.selectedFormats = null
  $scope.selectedTerms = null

  $scope.categoriesPlaceholder = $translate.instant('categoryPlaceholder')

  const api = {
    getCreateFormatController,
    getCreateTagController,
    getUseTermsCreateEditDialogController,
    _getFormatsSuggestions,
    _removeDuplicatedCategories,
    _successGetFormatsSuggestions,
    _getFormats,
    _successGetFormats,
    _getUseTerms,
    _successGetUseTerms,
    _getCategories,
    _successGetCategories,
    _getSelectedCategories,
    _successGetSelectedCategories,
    _customizeRows,
    _hasMoreResults,
    _checkPricing,
    _getFormatById,
    _successGetFormatById,
    _throwResponseError,
    _reloadData,
    _addCreatedFormatToOptions,
    _addCreatedTagToOptions
  }

  this.getApi = () => api

  activate()

  function activate () {
    const promises = [
      api._getFormatsSuggestions(),
      api._getFormats(true),
      api._getCategories(true, null)
    ]

    if ($scope.features[ARTS_USE_TERMS] || $scope.addons[ARTS_USE_TERMS]) {
      promises.push(api._getUseTerms(true))
    }

    Promise.all(promises).then(() => {
      api._checkPricing()
    }).finally(() => {
      $timeout(() => {
        $scope.tabsLoadingData.generalTab = false
      }, 100)
    })
  }

  $scope.$on('template-props.reload-data', () => {
    $timeout(() => {
      api._reloadData()
    })
  })

  $scope.toggleOptionalContainer = (event) => {
    $scope.optional[event.detail.name] = !$scope.optional[event.detail.name]

    const checkboxes = {
      terms: () => {
        $scope.formProperties.useTerms = ''
        $scope.selectedTerms = null
      },
      instructions: () => {
        $scope.formProperties.useInstructions = ''
      }
    }

    if (checkboxes[String(event.detail.name)]) {
      checkboxes[String(event.detail.name)]()
    }
  }

  $scope.onChangeTitle = (event) => {
    $scope.formProperties.title = event.detail.value
  }

  $scope.onInfiniteFormats = (event) => {
    $scope.flags.formatOptions.skip = $scope.flags.formatOptions.top + $scope.flags.formatOptions.skip
    const searchTerm = event.detail?.search || ''
    const search = isRunningFormatSearch ? searchTerm : ''

    api._getFormats(false, search)
  }

  $scope.onChangeFormats = (event) => {
    const selectedFormat = event.detail?.value
    isRunningFormatSearch = false

    $scope.formProperties.selectedFormat = selectedFormat
    $scope.formProperties.format = selectedFormat?.value ? selectedFormat.value : null
  }

  $scope.onSearchFormats = (event) => {
    const search = event.detail?.search || ''
    $scope.flags.formatOptions.skip = 0

    if (search) {
      isRunningFormatSearch = true
    } else {
      isRunningFormatSearch = false
    }

    api._getFormats(false, search)
  }

  $scope.onChangeTerms = (event) => {
    const selectedTerm = event.detail.value

    $scope.formProperties.useTerms = selectedTerm
  }

  $scope.onInfiniteCategories = (event) => {
    const search = event.detail?.search || ''

    $scope.flags.categories.skip = $scope.flags.categories.top + $scope.flags.categories.skip

    api._getCategories(false, search)
  }

  $scope.onChangeCategories = (event) => {
    const selectedCategories = event.detail

    $scope.formProperties.categories = selectedCategories.map(category => category.value)
  }

  $scope.onSearchCategories = (event) => {
    const search = event.detail?.search || ''
    $scope.flags.categories.skip = 0

    api._getCategories(true, search)
  }

  $scope.onClickPricing = (type) => {
    const types = {
      useTerms: {
        featureName: $translate.instant('billingFeatures.artsUseTerms'),
        featureSlug: ARTS_USE_TERMS
      }
    }

    const modalData = types[String(type)]

    if (!$scope.addons[String(modalData.featureSlug)] && !$scope.features[String(modalData.featureSlug)]) {
      $scope.openUpgradeCompanyPlanDialog({
        modalData
      })
    }
  }

  $scope.createFormat = () => {
    api.getCreateFormatController().then(({ CreateFormatController }) => {
      const createFormat = UdsModalService.createModal({
        controller: CreateFormatController,
        modalName: 'createFormat',
        data: {
          flag: 'create'
        },
        onClose: (returnData) => {
          if (returnData?.success && returnData?.createdFormat?.id) {
            api._addCreatedFormatToOptions(returnData.createdFormat.id)
          }
        },
        onOpen: () => {}
      })

      createFormat.open()
    })
  }

  $scope.createTag = () => {
    api.getCreateTagController().then(({ CreateTagController }) => {
      const createTag = UdsModalService.createModal({
        controller: CreateTagController,
        modalName: 'createTag',
        data: {
          flag: 'create',
          location: 'arts'
        },
        onClose: (returnData) => {
          if (returnData?.success && returnData?.createdTag) {
            $timeout(() => {
              api._addCreatedTagToOptions(returnData.createdTag)
              $scope.flags.noCategories = false
            })
          }
        },
        onOpen: () => {}
      })

      createTag.open()
    })
  }

  $scope.createUseTerms = () => {
    if (!$scope.features[ARTS_USE_TERMS] && !$scope.addons[ARTS_USE_TERMS]) return
    api.getUseTermsCreateEditDialogController().then(({ UseTermsCreateEditDialogController }) => {
      ModalService.showModal({
        templateId: 'useTermsCreateEdit.html',
        templateUrl: '/arts/dialogs/use-terms/create-edit/use-terms-create-edit-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: UseTermsCreateEditDialogController
      }).then(() => {
        $timeout(() => {
          api._getUseTerms(false)
        }, 0, true)
      })
    })
  }

  $scope.closeSuggestions = () => {
    $scope.flags.categories.hideSuggestions = true
  }

  $scope.clickSuggestion = (format) => {
    const mappedFormat = api._customizeRows([format])?.[0]
    $scope.flags.suggestions = true

    $scope.selectedFormats = mappedFormat
    $scope.formProperties.selectedFormat = mappedFormat
    $scope.formProperties.format = format.id
  }

  function _getFormatsSuggestions () {
    if (!$scope.data.shouldConvertToTemplate || !$scope.data.isCustomizable || !$scope.data?.art) {
      return
    }

    const templateLayers = $scope.data.art?.layers

    if (!templateLayers?.length) {
      return
    }

    const { height, width, sizeUnit: unit } = templateLayers[0]

    if (!unit) {
      return
    }

    return FormatsService.getFormatsSuggestions({ height, width, unit: unit.toUpperCase() })
      .then(api._successGetFormatsSuggestions)
      .catch(api._throwResponseError)
  }

  function _successGetFormatsSuggestions (response) {
    $scope.formatsSuggestions = response
  }

  function _getFormats (firstLoading, search = '') {
    return FormatsService.getFormats({ ...$scope.flags.formatOptions, search })
      .then(response => api._successGetFormats(firstLoading, response))
      .catch(api._throwResponseError)
  }

  function _successGetFormats (firstLoading, response) {
    if (firstLoading && !response.rows.length) {
      $scope.flags.noFormats = true
      return
    }

    if (firstLoading) {
      $scope.formats = []
    }

    $scope.flags.noFormats = false
    $scope.formats = api._customizeRows(response.rows)
    $scope.flags.formatOptions.hasMoreOptions = api._hasMoreResults(response.count, $scope.formats.length)
  }

  function _getUseTerms (firstLoading, search = '') {
    UseTermsService.getUseTerms({ search })
      .then(response => api._successGetUseTerms(firstLoading, response))
      .catch(api._throwResponseError)
  }

  function _successGetUseTerms (firstLoading, response) {
    if (firstLoading && !response.length) {
      $scope.flags.noUseTerms = true
      return
    }

    $scope.flags.noUseTerms = false

    $scope.useTerms = response.map(useTerm => {
      const useTermsFormatted = useTerm.useTerms.replace(/(<([^>]+)>)/ig, '')
      return {
        ...useTerm,
        useTermsFormatted,
        label: useTerm.title,
        value: useTerm.id
      }
    })

    $scope.useTerms.forEach(useTerm => {
      if (useTerm.value === $scope.formProperties.useTerms) {
        useTerm.active = true

        $scope.selectedTerms = useTerm
      }
    })
  }

  function _getCategories (firstLoading, search = '') {
    return TagsService.getTags({
      name: search,
      top: $scope.flags.categories.top,
      skip: $scope.flags.categories.skip
    })
      .then(response => api._successGetCategories(firstLoading, response, search))
      .catch(api._throwResponseError)
  }

  function _successGetCategories (firstLoading, response, search) {
    if (firstLoading && !response.rows.length && !search) {
      $scope.flags.noCategories = true
      return
    }

    $scope.flags.noCategories = false

    if (firstLoading) {
      $scope.categories = []
    }
    const filteredResponseRows = api._removeDuplicatedCategories(response.rows)
    $scope.categories = $scope.categories.concat(api._customizeRows(filteredResponseRows))
    $scope.flags.categories.hasMoreOptions = api._hasMoreResults(response.count, $scope.categories.length)
  }

  function _getSelectedCategories () {
    return TagsService.getTags({
      top: 100,
      skip: 0,
      tagsIds: $scope.formProperties.categories
    })
      .then(api._successGetSelectedCategories)
      .catch(api._throwResponseError)
  }

  function _successGetSelectedCategories (response) {
    if (response.rows?.length) {
      $scope.selectedCategories = api._customizeRows(response.rows)
    }
  }

  function _customizeRows (rows) {
    return rows.map(row => {
      return {
        ...row,
        label: row.name,
        value: row.id
      }
    })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  function _checkPricing () {
    if (!$scope.features[ARTS_USE_TERMS] && !$scope.addons[ARTS_USE_TERMS]) {
      $scope.flags.useTerms.pricing = true
    }
  }

  function _removeDuplicatedCategories (newCategories) {
    const existingCategories = $scope.categories
    const uniqueCategories = newCategories.reduce((items, newCategory) => {
      const itemExists = existingCategories.find(category => category.id === newCategory.id)

      if (!itemExists) {
        items.push(newCategory)
      }

      return items
    }, [])

    return uniqueCategories
  }

  function _getFormatById (id) {
    FormatsService.getFormatById(id)
      .then(response => api._successGetFormatById(response))
      .catch(api._throwResponseError)
  }

  function _successGetFormatById (response) {
    $scope.formProperties.selectedFormat = response
    $scope.selectedFormats = {
      ...response,
      label: response.name,
      value: response.id,
      active: true
    }
  }

  function _throwResponseError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _addCreatedFormatToOptions (formatId) {
    FormatsService.getFormatById(formatId)
      .then((response) => {
        const format = api._customizeRows([response])
        const oldFormats = [...$scope.formats]

        $timeout(() => {
          $scope.formats = [...oldFormats, ...format]
        })
      })
  }

  function _addCreatedTagToOptions (tag) {
    const customizedTag = api._customizeRows([tag])
    const oldTags = [...$scope.categories]

    $timeout(() => {
      $scope.categories = [...oldTags, ...customizedTag]
    })
  }

  function _reloadData () {
    if ($scope.features[ARTS_USE_TERMS] || $scope.addons[ARTS_USE_TERMS]) {
      api._getUseTerms(false)
    }

    if ($scope.formProperties.format) {
      api._getFormatById($scope.formProperties.format)
    }

    if ($scope.formProperties.categories?.length) {
      api._getSelectedCategories()
    }

    $timeout(() => {
      if ($scope.formProperties.useInstructions) {
        $scope.optional.instructions = true
      }

      if ($scope.formProperties.useTerms) {
        $scope.optional.terms = true
      }
    }, 500, true)
  }
}

export { GeneralPropertiesController }
